import {fetchGet, fetchPost, fetchPut} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const switchGirl = (
    venueId,
    dancerId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        venueId: venueId,
        dancerId: dancerId
    };
    fetchPost(
        uri + "/venue/switchdancer",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const endTipping = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        venueId: venueId
    };
    fetchPost(
        uri + "/venue/endtipping",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};

export const findVenueStageQueue = (
    venueId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/venue/stage/queue",
        successMethod,
        errorMethod,
        getAccessTokenSilently);
};

export const updateVenueStageQueue = (
    venueId,
    stageQueue,
    rotation,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        stageQueue: stageQueue,
        rotation: rotation
    };
    fetchPut(
        uri + "/venue/" + venueId + "/venue/stage/queue",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};
